
































import {AccountTypeEnum, PartyModel, TenantUserModel} from '@/libs/Api';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { partiesStore } from '@/libs/parties/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Ref, VModel, Watch } from 'vue-property-decorator';
import Autocomplete from '../components/Autocomplete.vue';
import { Guid } from '../functions/guid';
import {authStore} from "@/libs/auth/+store/store";
import {AuthGetter} from "@/libs/auth/models/auth-state";

@Component({ })
export default class PartySelect extends Page {

    loading = false;
    search = "";
    debounce: any = null;
    key = Guid.NewGuid();
    items: PartyModel[] = [];

    @VModel() innerValue!: string;
    @Prop({ default: "" }) label!: string;
    @Prop() type!: string | Array<string>;
    @Prop() readonly!: boolean;
    @Prop() rules!:  any[];
    @Prop({ default: false }) required!: boolean;
    @Prop({ default: false }) disabled!: boolean;
    @Prop({ default: false }) createParty!: boolean;
    @Prop({ default: false }) dense!: boolean;
    @Prop({ default: true }) hideDetails!: boolean;
    @Prop({ default: true }) clearable!: boolean;
    @Prop({ default: true }) simple!: boolean;
    @Prop() placeholder!: string;
    @Prop({ default: null }) districtId!: string | null;
    @Prop({ default: null }) townId!: string | null;

    @Ref() autocomplete!: Autocomplete;

    @Watch("innerValue")
    innerValueChanged(v: string, p: string) {
        console.log("UserSelect", v, p);
        if (v != p) {
            this.$emit("change", v);
        } 
    }

    @Watch("search")
    searchChanged (v: string, p: string) {
        if (this.innerValue == null && v != p) {
            this.loadItems();
        }
        else if (this.innerValue != null && v != null && (v.length == 1 || v.length == 0)) {
            this.$emit("input", null);
        }
    }

	@Watch("districtId")
	districtIdChanged() {
		this.loadItems();
	}

    mounted() {
        this.loadItems();
    }

    loadItems() {
        this.loading = true;
        clearTimeout(this.debounce);
        this.debounce = setTimeout(() => {
            var filters: Array<any> = [];
            if (this.innerValue != null && this.innerValue.toString().length > 0) {
                filters.push({
                    field: "id",
                    op: "eq",
                    comparand: this.innerValue,
                    junction: "and"
                });
            }
            else if (this.search != null && this.search.length > 0) {
                const parts = this.search.split(" ");
                for (var p of parts) {
                    if (p?.length == 0)
                        continue;
                    filters.push({
                        field: "firstname",
                        op: "wrap",
                        comparand: [
                            {
                                field: "firstname",
                                op: "c",
                                comparand: p.trim(),
                                junction: "or"
                            },
                            {
                                field: "lastname",
                                op: "c",
                                comparand: p.trim(),
                                junction: "or"
                            }
                        ],
                        junction: "and"
                    });
                }
            }
			const tenantUser = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
			if (tenantUser.accountType == AccountTypeEnum.Worker) {
				filters.push({ field: "partyCareProviders.userId", op: "eq", comparand: tenantUser.userId! });
			}
            if (this.districtId) {
                filters.push({ field: "districtId", op: "eq", comparand: this.districtId! });
            }
            if (this.townId) {
                filters.push({ field: "townId", op: "eq", comparand: this.townId! });
            }
            partiesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<PartyModel>([
                {
                    field: "lastName",
                    index: 1,
                    order: "asc"
                },
                {
                    field: "firstName",
                    index: 2,
                    order: "asc"
                }
            ], filters, {
                pageIndex: 1,
                pageSize: 25
            }, false, this.key));
            this.subscribe(partiesStore, CrudReponse.GetAll, this.key).then((e: PartyModel[]) => {
                this.loading = false;
                this.items = e;
            });
        }, 300)
    }

}
